import React, { useState } from "react";
import { Card } from "react-bootstrap";
import "./index.scss";
import { CartIcon2 } from "../../assets/icons/CartIcon2";
import { useCart } from "../../context/CartContext";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useClientAuth } from "../../context/ClientAuthContext";
import { HeartIcon } from "../../assets/icons/HeartIcon";
import WishlistButton from "../WishlistButton";

const ProductCard = ({ product }) => {
  const [hover, setHover] = useState(false);
  const { addToCart } = useCart();
  // ✅ Vérifier si promo active
  const { currentClient, handleClientLogout } = useClientAuth();
  const navigate = useNavigate();
  const now = new Date();
  const promoStart = product?.promoStartDate
    ? new Date(product.promoStartDate)
    : null;
  const promoEnd = product?.promoEndDate
    ? new Date(product.promoEndDate)
    : null;

  const isPromoActive =
    product?.isOnPromo &&
    promoStart &&
    promoEnd &&
    now >= promoStart &&
    now <= promoEnd;

  // ✅ Calculer prix final si promo active
  let finalPrice = product?.ttc || 0;
  if (isPromoActive && product?.pourcentagePromo) {
    finalPrice = (product.ttc * (100 - product.pourcentagePromo)) / 100;
  }
  const handleAddToCart = () => {
    const imageUrls =
      product?.imagePrincipale?.map(
        (img, index) =>
          `https://api.almasecret.msit-demo.fr/products/${product?._id}/image/${index}`
      ) || [];
    const productToAdd = {
      _id: product._id,
      title: product.title,
      price: finalPrice, // prix final avec promo si applicable
      quantity: 1,
      quantite: product.quantite,
      image: imageUrls[0], // pour affichage dans panier
    };

    addToCart(productToAdd);
  };

  return (
    <div
      className="product-card"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}>
      <div className="image-container">
        <img
          src={`https://api.almasecret.msit-demo.fr/products/${product?._id}/image/${0}`}
          alt={product.title}
          className={`product-img ${hover ? "hide" : "show"} `}
          onClick={() => {
            navigate(`/details-product/${product?._id}`);
            window.scrollTo(0, 0);
          }}
        />
        <img
          src={`https://api.almasecret.msit-demo.fr/products/${product?._id}/image/${1}`}
          alt={product.title}
          className={`product-img ${hover ? "show" : "hide"} `}
          onClick={() => {
            navigate(`/details-product/${product?._id}`);
            window.scrollTo(0, 0);
          }}
        />
        {currentClient && (
          <div className="heart-badge">
            <WishlistButton
              productId={product?._id}
              userId={currentClient?.userId}
            />
          </div>
        )}
        <button
          className="cart-icon"
          onClick={() => {
            if (product?.quantite > 0) {
              handleAddToCart();
            } else {
              alert("Produit en rupture de stock");
            }
          }}>
          <CartIcon2 />
        </button>
        <div className="category-label">{product?.categoryId?.title}</div>
      </div>
      {isPromoActive && (
        <div className="promo-badge">{product.pourcentagePromo}%</div>
      )}
      <div className="d-flex  justify-content-between ">
        <div className="product-title">{product.title}</div>

        <div className="price">
          {isPromoActive ? (
            <>
              {finalPrice.toFixed(3)} <span> DT</span>
              <p className="old-price ms-3">{product.ttc.toFixed(3)} DT</p>{" "}
            </>
          ) : (
            <>
              {product.ttc.toFixed(3)}
              <span> DT</span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
